// material-ui
import { useTheme } from '@mui/material/styles';



import logoIcon from 'assets/images/logoIcon.png';
import logoIconDark from 'assets/images/logoIcon.png';
import { ThemeMode } from 'config';
import { useHospitalDetails } from 'api/cutsom-hooks';
import { pickHospitalLogo } from 'utils/gst';


// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();
  const hospitalData = useHospitalDetails();
  const fallbackLogo = theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon;
  const configuredLogo = pickHospitalLogo(hospitalData, fallbackLogo, ['app_icon', 'app_logo']);

  return (

    <img src={configuredLogo} alt="Hospital" width="80" />

  );
}
